export function toBRL(value: string | number) {
  if (typeof value === 'string') value = parseFloat(value);

  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function toReadableNumber(value: string | number) {
  if (typeof value === 'string') value = parseFloat(value);

  return new Intl.NumberFormat('pt-BR').format(value);
}

export function toReadableDate(date: Date | string) {
  if (typeof date === 'string') date = new Date(date);

  return date.toLocaleDateString('pt-BR');
}

export function toCPF(value: string) {
  value = value.replace(/\D/g, '');
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function toCNPJ(value: string) {
  value = value.replace(/\D/g, '');
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function toDuration(totalInSeconds: number) {
  const hours = Math.floor(totalInSeconds / 3600);
  const minutes = Math.floor((totalInSeconds - hours * 3600) / 60);
  const secondsNum = Math.floor(totalInSeconds - 3600 * hours - 60 * minutes);
  const seconds = secondsNum < 10 ? '0' + secondsNum : String(secondsNum);

  if (!hours) return `${minutes}:${seconds}`;

  return `${hours}:${minutes}:${seconds}`;
}

/** month is 0-indexed (0 = January), matching API month_reference / monthReference */
export function formatMonthYearRef(month?: number | null, year?: number | null): string | null {
  if (month === undefined || month === null || year === undefined || year === null) return null;
  const mm = String(Math.max(0, Math.min(11, month)) + 1).padStart(2, '0');
  return `${mm}/${year}`;
}

type EditorialBook = {
  type?: string;
  isbn?: string | null;
  monthReference?: number;
  yearReference?: number;
  referenceMonth?: number;
  referenceYear?: number;
  monthFeatured?: number;
  monthFeaturedYear?: number;
};

export function getEditorialIdentifier(
  book: EditorialBook | null | undefined,
  monthReference?: number,
  yearReference?: number
): { label: string; value: string } | null {
  if (!book) return null;

  if (book.type === 'magazine-partiu') {
    const month = monthReference ?? book.monthReference ?? book.referenceMonth ?? book.monthFeatured;
    const year = yearReference ?? book.yearReference ?? book.referenceYear ?? book.monthFeaturedYear;
    const ref = formatMonthYearRef(month, year);
    if (!ref) return null;
    return { label: 'Ref', value: ref };
  }

  if (!book.isbn) return null;

  if (book.type === 'magazine') {
    return { label: 'ISSN', value: book.isbn };
  }

  return { label: 'ISBN', value: book.isbn };
}

